module.exports = __webpack_public_path__ + "static/img/maximus-en.d933419.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maximus-en.png
// module id = oZCp
// module chunks = 18